import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Params } from '@angular/router';
import { ApiQWorkardsEnv } from '@qaroni-core/config/apis/api-qworkards/api-qworkards.config';
import { Check } from '../types/check';
import { CheckApiObject } from '../types/check-response';
import { JourneyApiObject } from '../types/journey-response';

@Injectable({
  providedIn: 'root',
})
export class CheckWidgetHttpService {
  private http = inject(HttpClient);

  // ==========================================================================================
  // CREATE
  // ==========================================================================================

  public toggleCheck$(employeeID: number, check: Check) {
    const url = `${ApiQWorkardsEnv.baseUrl}/employees/${employeeID}/checks`;
    return this.http.post<CheckApiObject>(url, check, {
      observe: 'response',
    });
  }

  // ==========================================================================================
  // READ
  // ==========================================================================================

  public getJourney$(employeeID: number, params: Params) {
    const url = `${ApiQWorkardsEnv.baseUrl}/employees/${employeeID}/checks/journeys/actives/temps`;
    return this.http.get<JourneyApiObject>(url, {
      observe: 'response',
      params,
    });
  }
}
